export default __webpack_public_path__ + "static/media/cdlog.7f8a0e56.jpg";